import * as React from 'react'
import { styled } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateRight } from '@fortawesome/pro-solid-svg-icons'

export interface PreviewErrorProps {
  onRetry: () => void
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
`

const RetryButton = styled.button.attrs({
  className: 'btn btn-lg text-white text-uppercase fw-bold px-4 py-3'
})``

export const PreviewError: React.FC<PreviewErrorProps> = ({ onRetry }) => (
  <Container>
    <h3>Es ist etwas schiefgelaufen</h3>
    <p>Die Vorschau konnte gerade nicht erstellt werden. Bitte versuche es in einem Moment erneut.</p>
    <RetryButton type="button" onClick={onRetry}>
      Erneut versuchen
      <FontAwesomeIcon icon={faRotateRight} className="ms-3" />
    </RetryButton>
  </Container>
)
